var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pizzaChart",staticStyle:{"width":"50%","height":"400px"},attrs:{"id":"pizza-chart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }